import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MarqueeProps {
    children: ReactNode
    className?: string
    trackClassName?: string
}

export const Marquee: FC<MarqueeProps> = ({ children, className, trackClassName }): ReactNode => {
    return (
        <div className={cn('group relative flex overflow-hidden', className)}>
            <div className='flex w-max shrink-0 animate-marquee group-hover:[animation-play-state:paused]'>
                <div className={cn('flex shrink-0 items-center', trackClassName)}>
                    {children}
                </div>

                <div className={cn('flex shrink-0 items-center', trackClassName)} aria-hidden='true'>
                    {children}
                </div>
            </div>
        </div>
    )
}
